// extracted by mini-css-extract-plugin
export var footer = "footer-module--footer--hu0V0";
export var footer__container = "footer-module--footer__container--VTKTK";
export var footer__container__left = "footer-module--footer__container__left--leUek";
export var footer__container__right = "footer-module--footer__container__right--m7PzM";
export var footer__social = "footer-module--footer__social--cVxI8";